import { Box } from "@mui/material";
import { Cookies, withCookies } from "react-cookie";
import BulleFixed from "../../../components/BulleFixed";
import BlocAvantages from "./BlocAvantages";
import BlocBackground from "./BlocBackground";
import BlocDescription from "./BlocDescription";
import BlocDevis from "./BlocDevis";
import BlocFonctions from "./BlocFonctions";
import BlocMaintenance from "./BlocMaintenance";
import BlocOffres from "./BlocOffres";
import BlocQuiSommesNous from "./BlocQuiSommesNous";
import BlocTemoignages from "./BlocTemoignages";
import ContactForm from "./ContactForm";
import styles from "./styles";
import { useEffect, useState } from "react";
interface Props {
  // Surcharge de style CSS injecté par withStyles
  cookies: Cookies;
}

function Accueil({ cookies }: Props) {
  /**
   * Récupération d'un cookie coté client
   */
  const [cookiesPub, setCookiesPut] = useState<boolean>(false);
  const [cookiesGlobal, setCookiesGlobal] = useState<boolean>(false);
  useEffect(() => {
    window._axcb.push((sdk: any) => {
      sdk.on("cookies:complete", (choices: any) => {
        setCookiesGlobal(choices.Matomo);
        setCookiesPut(choices.Youtube);
      });
    });
  }, []);
  return (
    <Box sx={styles}>
      {/** Titre */}
      <BlocBackground />
      <BlocMaintenance />
      <BlocQuiSommesNous /> <BlocTemoignages cookiesValid={cookiesPub} />
      <BlocDescription />
      <BlocFonctions cookiesValid={cookiesGlobal} />
      <BlocAvantages />
      <BlocOffres />
      <BlocDevis cookiesValid={cookiesGlobal} />
      <div className={"containerYoutube"}>
        <iframe
          className={"iframeYoutube"}
          title="youtube"
          width="645"
          height="367"
          src={
            cookiesPub
              ? "https://www.youtube.com/embed/R6eiU7S4mlE"
              : "https://www.youtube-nocookie.com/embed/R6eiU7S4mlE"
          }
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        />
      </div>
      <ContactForm />
      <BulleFixed />
    </Box>
  );
}

export default withCookies(Accueil);
